import React from 'react'
import t from 'prop-types'
import Image from '../Image'
import cx from 'classnames'

const ImageRounded = ({ alt, src, reverse }) => {
  return (
    <div
      className={cx('mb-16 md:mb-0 last:mb-0 overflow-hidden', {
        'rounded-r-xl sm:rounded-r-2xl': reverse,
        'rounded-l-xl sm:rounded-l-2xl': !reverse,
      })}
    >
      <Image src={src} alt={alt} />
    </div>
  )
}

ImageRounded.propTypes = {
  alt: t.string,
  src: t.string,
  reverse: t.bool,
}

ImageRounded.defaultProps = {
  reverse: false,
}

export default ImageRounded
